import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import Container from '../components/Container/Container';
import ContainerBG from './../components/ContainerBG/ContainerBG';
import Button from '../components/Button/Button';
import Architects from '../components/Architects/Architects';
import Montage from '../components/Montage/Montage';
import Arrange from '../components/Arrange/Arrange';

const StyledContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const StyledHeader = styled.h1`
  color: ${({ theme }) => theme.colors.light};
  font-size: ${({ theme }) => theme.headers.h1};
  font-family: ${({ theme }) => theme.fonts.headerFont};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  text-shadow: 0 0 15px rgba(0, 0, 0, 0.9);
  text-align: center;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    font-size: 45px;
    line-height: 1.2em;
  }
`;

const IndexPage = ({ data }) => {
  return (
    <>
      <ContainerBG image={data.startimage.childImageSharp.gatsbyImageData}>
        <Container tag='div' padding='16px' height='100vh' fluid flex>
          <StyledHeader>Najpiękniejsze tapety w Koszalinie</StyledHeader>
        </Container>
      </ContainerBG>
      <Container fluid>
        <StyledContainer height='100vh' fluid>
          <ContainerBG
            image={data.objectWallpaper.childImageSharp.gatsbyImageData}>
            <Container height='50vh' fluid flex>
              <Button link='/tapety-obiektowe' arrow='true' color='#fff'>
                tapety <br />
                obiektowe
              </Button>
            </Container>
          </ContainerBG>
          <ContainerBG
            image={data.decorativeWallpaper.childImageSharp.gatsbyImageData}>
            <Container height='50vh' fluid flex>
              <Button link='/tapety-dekoracyjne' arrow='true' color='#fff'>
                tapety
                <br />
                dekoracyjne
              </Button>
            </Container>
          </ContainerBG>
          <ContainerBG
            image={data.photowallpaper.childImageSharp.gatsbyImageData}>
            <Container height='50vh' fluid flex>
              <Button link='/fototapety' arrow='true' color='#fff'>
                fototapety
              </Button>
            </Container>
          </ContainerBG>
          <ContainerBG image={data.textiles.childImageSharp.gatsbyImageData}>
            <Container height='50vh' fluid flex>
              <Button link='/tkaniny' arrow='true' color='#fff'>
                tkaniny
              </Button>
            </Container>
          </ContainerBG>
        </StyledContainer>
      </Container>
      <Arrange />
      <Architects />
      <Montage />
    </>
  );
};

export const query = graphql`
  {
    startimage: file(name: { eq: "main-image" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    objectWallpaper: file(
      name: { eq: "object-wallpaper_0008331_386614_hover" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    decorativeWallpaper: file(
      name: { eq: "decorative-wallpaper_0011017_307344_hover" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    photowallpaper: file(name: { eq: "phototwallpapers_R14592_image3" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    textiles: file(
      name: { eq: "textiles-igu-iguacu-ambiance_T1624006630443" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
  }
`;

export default IndexPage;
